export default __webpack_public_path__ + "static/media/2.9ae62051.webp";